import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import ProfileTab from '@/components/settings/ProfileTab';
import TeamTab from '@/components/settings/TeamTab';
import IntegrationsTab from '@/components/settings/IntegrationsTab';
import OrganizationTab from '@/components/settings/OrganizationTab';

const TABS = [
    { key: 'profile', label: 'Profile' },
    { key: 'organization', label: 'Organization' },
    { key: 'team', label: 'Team' },
    { key: 'integrations', label: 'Integrations' },
];

export default function SettingsPage() {
    const { tab } = useParams();
    const { profile } = useAuth();
    const navigate = useNavigate();
    const active = tab || 'profile';

    if (profile?.role !== 'admin' && active !== 'profile') {
        return (
            <div className="max-w-3xl mx-auto p-6 lg:p-10">
                <ProfileTab />
            </div>
        );
    }

    return (
        <div className="max-w-5xl mx-auto px-4 lg:px-6 py-6" data-testid="settings-page">
            <h1 className="text-2xl font-bold tracking-tight text-aks-text">Settings</h1>
            <p className="text-[13px] text-gray-500 mt-1">Workspace, team and integrations</p>
            <div className="mt-6 border-b border-gray-200 flex gap-6 overflow-x-auto">
                {TABS.map((t) => {
                    if (profile?.role !== 'admin' && t.key !== 'profile') return null;
                    const isActive = active === t.key;
                    return (
                        <button key={t.key} onClick={() => navigate(`/settings/${t.key}`)} className={`cursor-pointer pb-3 -mb-px border-b-2 text-[14px] font-semibold transition ${isActive ? 'border-aks-gold text-aks-navy' : 'border-transparent text-gray-500 hover:text-aks-navy'}`} data-testid={`settings-tab-${t.key}`}>
                            {t.label}
                        </button>
                    );
                })}
            </div>
            <div className="mt-6">
                {active === 'profile' && <ProfileTab />}
                {active === 'organization' && <OrganizationTab />}
                {active === 'team' && <TeamTab />}
                {active === 'integrations' && <IntegrationsTab />}
            </div>
        </div>
    );
}
